<template>
  <div>
    <HotelOffersFilter
      :filteringCategories="filteringCategories.filter(item => item.value !== 'vouchers')"
      :selectedFilter="selectedFilter"
      @selectFilter="selectFilter"
      dataTestIdLocation="step1"
    />
    <div class="tw:max-h-[300px] tw:overflow-auto tw:px-1 tw:flex tw:flex-col tw:gap-y-3">
      <HotelOfferModalItem
        v-for="item in activeTemplates"
        :class="offer?.name === item.name ? 'selected-item' : 'item'"
        :key="item.name"
        :item="item"
        :isClickable="true"
        :icons="icons"
        :selectedItem="offer"
        @selectOffer="selectNewOffer"
      />
      <div class="tw:pb-8 tw:pt-4">
        <p class="tw:text-sm tw:text-gray-800">
          {{ $t('hotel_offers_not_found') }}
        </p>
        <button @click="openSuggestionsModal" class="tw:text-blue-700 tw:font-bold tw:text-sm">
          {{ $t('hotel_offers_cta_ideas') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, nextTick, watch, computed } from 'vue'

import HotelOffersFilter from '@/components/hotelOffers/HotelOffersFilter.vue'
import HotelOfferModalItem from '@/components/hotelOffers/createOffer/HotelOfferModalItem.vue'

const emit = defineEmits(['selectOffer', 'selectFilter', 'openSuggestionsModal'])
const openSuggestionsModal = () => emit('openSuggestionsModal')
const selectNewOffer = offerName => emit('selectOffer', offerName)

const selectFilter = category => emit('selectFilter', category)
const props = defineProps({
  filteringCategories: {
    type: Array,
    default: () => [],
  },
  filteredTemplates: {
    type: Array,
    default: () => [],
  },
  selectedFilter: [Object, String],
  offer: Object,
  icons: Object,
})

const activeTemplates = computed(() => props.filteredTemplates?.filter(item => item?.status === 'ACTIVE'))
watch(
  () => props.selectedFilter,
  () => {
    nextTick(() => {
      const selectedElement = document.querySelector('.selected-item')
      const item = document.querySelector('.item')
      if (selectedElement) {
        selectedElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } else {
        item.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    })
  }
)

onMounted(() => {
  nextTick(() => {
    const selectedElement = document.querySelector('.selected-item')
    if (selectedElement) {
      selectedElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  })
})
</script>
